import { Injectable } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';

import { AuthenticationService } from './authentication.service';
import { LoginRouteService } from './login-route.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class IdleService {

	constructor(private idle: Idle, private authenticationService: AuthenticationService, private loginRouteService: LoginRouteService) {
		// Sets idle to 3 hours after which it will start the timeout counter.
		this.idle.setIdle(10895);
		// Use this to warn the user they're about to be logged out. If not called onTimeout will never happen
		this.idle.setTimeout(5);
		// Sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
		this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

		this.idle.onTimeout.pipe(switchMap(() => {
			return this.authenticationService.logout().pipe(
				switchMap(() => {
					localStorage.removeItem('SearchItemList');
					localStorage.removeItem('SearchQuery');
					localStorage.removeItem('ContextMapping');
					return this.loginRouteService.redirectToLogin();
				}));
		})).subscribe();
	}

	watch() {
		this.idle.watch();
	}
}
